export default __webpack_public_path__ + "static/media/KZ.M.11.2338 black.01d6767e.svg";